import { useSearchParams } from "react-router-dom";
import { useCallback, useMemo, useRef, useState } from "react";

export default function useQueryFilters() {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchTimeout = useRef();
  const [searchMessage, setSearchMessage] = useState("");

  const query = useMemo(() => {
    return {
      status: searchParams.get("status") || "",
      search: searchParams.get("search") || "",
      page: searchParams.get("page") || 1,
      limit: searchParams.get("limit") || 10, 
    };
  }, [searchParams]);

  const updateFilter = useCallback(
    (key, value) => {
      const params = new URLSearchParams(searchParams);

      if (value) params.set(key, value);
      else params.delete(key);

      if (key !== "page") {
        params.set("page", 1);
      }

      setSearchParams(params);
    },
    [searchParams, setSearchParams],
  );

  const handleSearch = useCallback(
    (value) => {
      clearTimeout(searchTimeout.current);

      if (value.length > 0 && value.length < 2) {
        setSearchMessage("Please type at least 2 characters");
        return;
      }

      setSearchMessage("");

      searchTimeout.current = setTimeout(() => {
        updateFilter("search", value);
      }, 1000);
    },
    [updateFilter],
  );

  return {
    query,
    updateFilter,
    handleSearch,
    searchParams,
    searchMessage
  };
}
